import * as Sentry from "@sentry/nextjs";

import {api} from "../_services/api";

export const fetchPaginatedLocationIdsForApptReason = ({
  reasonId,
  latitude,
  longitude,
  page,
  pageSize,
  distance,
}: {
  reasonId: string;
  latitude: number;
  longitude: number;
  page?: number; // default 1
  pageSize?: number; // Max of 50
  distance?: number; // Max of 3000
}): Promise<string[]> =>
  api
    .post(`/hib/reasons/${reasonId}/locations`, {latitude, longitude, page, pageSize, distance})
    .then(res => res.json())
    .catch(err => {
      Sentry.captureException(err);
      return [];
    });

/**
 * This API returns a max of 50 locations per request
 * Because we need to filter regions by availability,
 * we need to here find all locations which can service an apptReason,
 * not just the locations in selectedRegion and later filter by region
 * after slots/availability is known.
 *
 * Page number is set to 5 because it seems that most reasons will return
 * around 150 locations. 5 will give a safe buffer to account for additional locations.
 *
 * This can moved to the frontend to run on a specific coordinate with
 * every selectedRegion change after we have a null state to show that
 * there are no locations in the selectedRegion.
 */
export const fetchLocationsByReasonId = (reasonId: string, pageCount = 5) =>
  Promise.all(
    Array(pageCount)
      .fill(null)
      .map((x, i) =>
        fetchPaginatedLocationIdsForApptReason({
          reasonId,
          // Center of contiguous US
          latitude: 39,
          longitude: -98,
          distance: 3000,
          page: i + 1,
        }),
      ),
  )
    .then(pages => pages.flat())
    .catch(err => {
      Sentry.captureException(err);
      return [];
    });
